import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'app/shared/services/api.service';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit,OnDestroy  {
  @ViewChild('vform') validationForm: FormGroup;
  subMenuForm: FormGroup;
  subMenu2ndForm: FormGroup;
  mainMenuForm: FormGroup;
  fileData: File
  mainMenuFormSubmitted: boolean = false;
  selectType_mainMenu:any=null
  selectType_subMenu:any=null
  selectType_subMenu2nd:any=null
  firstModalRef: NgbModalRef;
  secondModalRef: NgbModalRef;


  typeList=[];
  typeId=  "6344000d91f6bc691e775faf" 

  currentUrl:any
  classes_list=[
    {name:'dropdown nav-item has-sub'},
    {name:'dropdown-item'},
    {name:' has-sub'},
  ]
  select_class_mainMenu=null
  select_class_subMenu=null
  select_class_subMenu3rd =null
  sub_menu_List=[]
  select_sub_menu=null

  mainMenuModel={
    path:'',
    title:  '',
    icon: 'ft-box',
    classes: '',
    isExternalLink: false,
    asignfor:'',
    submenu:[]
  }
 
  submenu_model={
    path:'',
    title:  '',
    icon: 'ft-arrow-right submenu-icon',
    classes: '',
    isShow: 'admin',
    isExternalLink: false,
    asignfor:'',
    submenu:[]
  }
  submenu_model2nd={
    path:'',
    title:  '',
    icon: 'ft-arrow-right submenu-icon',
    classes: '',
    isShow: 'admin',
    isExternalLink: false,
    asignfor:'',
    submenu:[]
  }
  sub_menu_List2nd=[]
  select_sub_menu2nd=null
  main_menu_id:any
  constructor(private formBuilder: FormBuilder, private http: HttpClient,
    public toastr: ToastrService, private activerouter: ActivatedRoute,
    public apiService: ApiService, private route: Router,
    private modalService: NgbModal,) {
    this.currentUrl = this.activerouter.snapshot.routeConfig.path
    this.activerouter.paramMap.subscribe(params => {
      this.main_menu_id = params.get('id');
    })
  }
  ngOnInit() {
    this.getEmployeeType()
    this.mainMenuForm = this.formBuilder.group({
      path:['',],
      title:  ['', Validators.required],
      icon: ['',],
      classes: ['',],
      isExternalLink: ['',],
    // submenu: submenu,
    // asignfor: asignfor,
    })
    this.getSubMenuList()
    if(this.currentUrl === 'edit-main-menu/:id'){
      this.getMainMenuById()
    }
    if(this.currentUrl === 'edit-sub-menu/:id'){
      this.getSubMenuById()
    }
  }
  get rf() {
    return this.mainMenuForm.controls;
  }
  getClassMainMenuId(event){
    this.select_class_mainMenu.name
    this.mainMenuModel.classes=this.select_class_mainMenu.name
  }
  getClassSubMenuId(event) {
    this.select_class_subMenu = event.name
    this.submenu_model.classes=this.select_class_subMenu
  }
  getClassSubMenu3Id(event){
    this.select_class_subMenu3rd.name
    this.submenu_model2nd.classes=this.select_class_subMenu3rd.name
  }
  getMainMenuById(){
    this.apiService.getMainMenuById(this.main_menu_id).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.mainMenuModel.title = res?.data[0]?.title
        this.mainMenuModel.path = res?.data[0]?.path
        this.select_class_mainMenu = res?.data[0]?.classes
        this.mainMenuModel.classes = this.select_class_mainMenu
        this.mainMenuModel.isExternalLink = res?.data[0]?.isExternalLink
        this.mainMenuModel.icon = res?.data[0]?.icon
        this.selectType_mainMenu = res?.data[0]?.asignfor.map(item=>item._id)
        this.mainMenuModel.asignfor = this.selectType_mainMenu
        this.select_sub_menu = res?.data[0]?.submenu.map(item=>item._id)
        this.mainMenuModel.submenu = this.select_sub_menu

      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
  getSubMenuById(){
    this.apiService.getSubMenuById(this.main_menu_id).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.mainMenuModel.title = res?.data[0]?.title
        this.mainMenuModel.path = res?.data[0]?.path
        this.select_class_subMenu = res?.data[0]?.classes
        this.mainMenuModel.classes = this.select_class_subMenu 
        this.mainMenuModel.isExternalLink = res?.data[0]?.isExternalLink
        this.mainMenuModel.icon = res?.data[0]?.icon
        this.selectType_mainMenu = res?.data[0]?.asignfor.map(item=>item._id)
        this.mainMenuModel.asignfor = this.selectType_mainMenu
        this.select_sub_menu = res?.data[0]?.submenu.map(item=>item._id)
        this.mainMenuModel.submenu = this.select_sub_menu

      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
  getEmployeeType(){
    this.apiService.getTagByTagCatgoryId(this.typeId).subscribe((res:any)=>{
      this.typeList=res.data
    })
  }
  getTypeMainMenuId(event:any){
    this.selectType_mainMenu
  }
  getTypeSubMenuId(event:any){
    this.selectType_subMenu
  }
  getTypeSubMenuId2nd(event:any){
    this.selectType_subMenu2nd
  }
  getSubMenuId(event:any){
    this.select_sub_menu
  }
  getSubMenuId2nd(event:any){
    this.select_sub_menu2nd
  }
  submit(){
    if(this.currentUrl === 'add'){
      let body={    
        path: this.mainMenuForm.value.path,
        title: this.mainMenuForm.value.title,
        isShow: 'admin',
        icon: 'ft-box',
        classes: this.select_class_mainMenu.name,
        isExternalLink: false,
        submenu: this.sub_menu_List?this.sub_menu_List:[],
        asignfor: this.selectType_mainMenu
    }
    this.apiService.mainMenuCreate(body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('Menu add successfully!')
        this.route.navigate(['control-management/list'])
      }
      else{
        this.toastr.error(res.error)
      }
    })
    }
    if(this.currentUrl === 'edit-main-menu/:id' && this.main_menu_id){
      this.mainMenuModel.submenu = this.select_sub_menu?this.select_sub_menu:[]
      this.mainMenuModel.asignfor = this.selectType_mainMenu
      this.apiService.mainMenuUpdate(this.main_menu_id,this.mainMenuModel).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('MainMenu update successfully!')
          this.route.navigate(['control-management/list'])
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    if(this.currentUrl === 'edit-sub-menu/:id' && this.main_menu_id){
      this.mainMenuModel.submenu = this.select_sub_menu?this.select_sub_menu:[]
      this.mainMenuModel.asignfor = this.selectType_mainMenu
      this.apiService.subMenuUpdate(this.main_menu_id,this.mainMenuModel).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('SubMenu update successfully!')
          this.route.navigate(['control-management/list'])
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
  } 

  back() {
    this.route.navigate(['control-management/list'])
  }
  openModal(content) {
    this.getSubMenuList()

    this.firstModalRef = this.modalService.open(content);
    this.firstModalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  openModal2nd(content) {
    this.getSubMenuList()

    this.secondModalRef = this.modalService.open(content);
    this.secondModalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  submitSubMenu(){
    this.submenu_model.submenu= this.select_sub_menu2nd?this.select_sub_menu2nd:[]
    this.submenu_model.asignfor = this.selectType_subMenu
    this.submenu_model.classes = this.select_class_subMenu?this.select_class_subMenu: this.classes_list[1].name
    this.apiService.subMenuCreate(this.submenu_model).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.getSubMenuList()
      }
      else{
        this.toastr.error(res.error)
      }
    })
    this.firstModalRef.dismiss()

  }
  submitSubMenu2nd(){
    this.submenu_model2nd.submenu = this.select_sub_menu2nd?this.select_sub_menu2nd:[]
    this.submenu_model2nd.asignfor = this.selectType_subMenu2nd
    this.apiService.subMenuCreate(this.submenu_model2nd).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.getSubMenuList()
      }
      else{
        this.toastr.error(res.error)
      }
    })
    this.secondModalRef.dismiss()

  }
  getSubMenuList(){
    this.apiService.getsubMenuList(1,100).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.sub_menu_List = res?.items
      }
    })
  }
  // submitRef() {

  //   this.referenceForm = this.formBuilder.group(this.reference_model);
  //   this.referenceList.push(this.referenceForm.value)
  //   this.referenceList = this.referenceList.map(item => item)
  //   this.referenceForm.reset(this.reference_model);
  //   this.modalService.dismissAll()
  // }

  // editItem(data, content) {
  //   console.log(data)
  //   this.reference_id = data._id
  //   this.reference_model.refId = this.reference_id
  //   this.reference_model.name = data.name
  //   this.reference_model.links = data.links
  //   this.reference_model.description = data.description
  //   this.reference_model.notes = data.notes
  //   this.reference_model.admin_notes = data.admin_notes
  //   this.reference_model.IP = data.IP
  //   this.jobs_id = data.job_id
  //   const modalRef = this.modalService.open(content);
  //   modalRef.result.then((result) => {
  //     // console.log(`Modal closed with result: ${result}`);
  //   }, (reason) => {
  //     // console.log(`Modal dismissed with reason: ${reason}`);
  //   });
  // }
  // updateRef() {
  //   let body = {
  //     references: [this.reference_model]
  //   }
  //   if (this.reference_id !== '') {
  //     this.apiService.updateJob(this.jobs_id, body).subscribe((res: any) => {
  //       if (res.statusCode === 200) {
  //         this.toastr.success('Reference update successfully')
  //         this.getJobsById()
  //         this.modalService.dismissAll()
  //       }
  //       else {
  //         this.toastr.error(res.error)
  //       }
  //     })
  //   }
  // }
  // deleteRef(password) {
  //   this.apiService.refDelete(this.reference_id, password).subscribe((res: any) => {
  //     if (res.statusCode === 200) {
  //       swal.fire({
  //         icon: "success",
  //         title: 'Deleted!',
  //         text: 'Your file has been deleted.',
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         },
  //       })
  //       this.getJobsById()
  //     }
  //     else {
  //       swal.fire({
  //         icon: "error",
  //         title: 'Error!',
  //         text: `${res.error}`,
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         },
  //       })
  //     }

  //   })
  // }

  // ================== Delete Alert ========================
  // confirmDelete(id: any) {
  //   this.reference_id = id
  //   swal.fire({
  //     text: "Please Enter Password",
  //     input: 'password',
  //     showCancelButton: true,
  //   }).then((result) => {
  //     if (result.value) {
  //       this.deleteRef(result.value)

  //     } else if (result.dismiss === swal.DismissReason.cancel) {
  //       swal.fire({
  //         title: 'Cancelled',
  //         text: 'Your file is safe :)',
  //         icon: 'error',
  //         customClass: {
  //           confirmButton: 'btn btn-success'
  //         },
  //       })
  //     }
  //   });
  // }

  ngOnDestroy(){
    this.mainMenuForm.reset()
    this.mainMenuModel.submenu=[]
    this.submenu_model.submenu=[]
    this.submenu_model2nd.submenu=[]
    this.selectType_mainMenu=''
    this.selectType_subMenu=''
    this.selectType_subMenu2nd=''
    this.select_sub_menu=''
    this.select_sub_menu2nd =''
  }
}
